<div class="modal mt-5" [class.show]="isVisible" [style.display]="isVisible ? 'block' : 'none'" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-lg" role="document" style="max-height: 90vh;">
    <div class="modal-content" *ngIf="selectedTagDefinition" style="max-height: 90vh; display: flex; flex-direction: column;">
      <div class="modal-header">
        <h5 class="modal-title">{{ selectedTagDefinition.id === 0 ? 'New Tag Definition' : 'Edit Tag Definition' }}</h5>
        <button type="button" class="close" (click)="onCancel()">
          <span>&times;</span>
        </button>
      </div>

      <div class="modal-body" style="overflow-y: auto; flex: 1;">
        <div class="form-group">
          <label>Engineer Friendly Name <span class="text-danger">*</span></label>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="selectedTagDefinition.engineerFriendlyName"
            placeholder="Enter engineer friendly name"
          />
        </div>

        <div class="form-group">
          <label>Base Device Type <span class="text-danger">*</span></label>
          <select class="form-control" [(ngModel)]="selectedTagDefinition.baseDeviceTypeId">
            <option [ngValue]="null">-- Select Base Device Type --</option>
            <option *ngFor="let type of filteredBaseDeviceTypes" [ngValue]="type.id">
              {{ type.name }}
            </option>
          </select>
        </div>

        <div class="form-group">
          <label>Data Type</label>
          <select class="form-control" [(ngModel)]="selectedTagDefinition.dataType">
            <option [ngValue]="null">-- Select Data Type --</option>
            <option *ngFor="let option of dataTypeOptions" [ngValue]="option.value">
              {{ option.label }}
            </option>
          </select>
        </div>

        <div class="form-group">
          <label>Default Value</label>
          <app-dynamic-value-input
            [dataType]="selectedTagDefinition.dataType"
            [defaultValue]="selectedTagDefinition.defaultValue"
            [(ngModel)]="selectedTagDefinition.defaultValue"
            [mode]="'input'"
            placeholder="Enter default value (comma-separated for dropdown options)"
          >
          </app-dynamic-value-input>
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="onCancel()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="onSave()">Save</button>
      </div>
    </div>
  </div>
</div>
<div class="modal-backdrop" [class.show]="isVisible" *ngIf="isVisible"></div>
